import { render } from "./SaveHoliday.vue?vue&type=template&id=e8574f8e&scoped=true"
import script from "./SaveHoliday.vue?vue&type=script&lang=js"
export * from "./SaveHoliday.vue?vue&type=script&lang=js"

import "./holiday.scss?vue&type=style&index=0&id=e8574f8e&lang=scss&scoped=true"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8574f8e"]])

export default __exports__